module.exports = __webpack_public_path__ + "static/media/18ECA29.78b61024.jpg";